<template>
  <div class="container" v-loading="loading" element-loading-text="Chargement des données ...">
    <div id="dashboard" class="hello">
      <div class="header clearfix" style="margin-top: 20px; margin-bottom: 20px;">
        <div class="pull-right" id="date-form">
          <div class="pull-right" style="margin-left: 20px;">
            Du
            <el-date-picker v-model="from" type="date" format="dd/MM/yyyy" v-on:change="load"></el-date-picker>
            au
            <el-date-picker v-model="to" type="date" format="dd/MM/yyyy" v-on:change="load"></el-date-picker>
          </div>
        </div>
        <img src="static/logo-full.png" style="max-width: 300px;"><br/>
        <p class="connected">Connecté en tant que {{ user.first_name }} {{ user.last_name }}, <el-button type="text" v-on:click="logout()">déconnexion</el-button>.</p>
      </div>

      <div class="row" style="margin: 40px 0 40px 0;">
        <div class="col-lg-12">
          <div id="chart" style="height: 400px;">
            <highcharts :options="highcharts" ref="highcharts"></highcharts>
          </div>
        </div>
      </div>

      <div class="row" style="margin: 40px 0 40px 0;">
        <div class="col-lg-12">
          <el-table :data="statistics.dates" height="500" :summary-method="getSummaries" show-summary>
            <el-table-column prop="date" label="Date" width="180"></el-table-column>
            <el-table-column prop="valid" class-name="valid-color" label="Valides"></el-table-column>
            <el-table-column prop="invalid" class-name="invalid-color" label="Invalides"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import Highcharts from 'highcharts'

  Highcharts.setOptions({
    lang: {
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
    }
  })

  export default {
    name: 'dashboard',
    created () {
      var self = this

      if (!this.$nexus.hasToken()) {
        this.$router.push('/')
      } else {
        this.$nexus.get('api', '/account/users/current')
          .then(function (response) {
            self.user = response.data.data
          })

        this.load()
      }
    },
    data () {
      return {
        loading: true,
        user: '',
        from: moment().subtract(30, 'days').toDate(),
        to: moment().toDate(),
        highcharts: {
          title: {
            text: false
          },
          xAxis: {
            type: 'datetime'
          },
          yAxis: {
            title: {
              text: 'Devis'
            }
          },
          series: [{
            name: 'Devis valides',
            lineWidth: 4,
            color: '#2980b9',
            data: []
          }, {
            name: 'Devis invalides',
            lineWidth: 4,
            color: '#f39c12',
            data: []
          }]
        },
        statistics: {
          dates: [],
          total: {
            valid: 0,
            invalid: 0
          }
        }
      }
    },
    methods: {
      load () {
        let self = this

        this.loading = true

        this.$nexus.get('api', '/product/quotes', {
          params: {
            with: 'statistics',
            where: {
              created_at: {
                between: moment(self.from).format('YYYY-MM-DD') + ' 00:00:00,' + moment(self.to).format('YYYY-MM-DD') + ' 23:59:59'
              }
            }
          }
        })
          .then(function (response) {
            let data = response.data.meta.statistics
            let chart = self.$refs.highcharts.chart

            self.statistics.dates = []
            self.statistics.total.valid = 0
            self.statistics.total.invalid = 0

            let highcharts = {
              valid: [],
              invalid: []
            }

            Object.keys(response.data.meta.statistics).map(function (key, index) {
              let date = key.split('-')
              let validCount = data[key].valid_count
              let invalidCount = data[key].invalid_count + data[key].unsold_count

              self.statistics.total.valid += validCount
              self.statistics.total.invalid += invalidCount

              highcharts.valid.push([Date.UTC(date[0], date[1] - 1, date[2]), validCount])
              highcharts.invalid.push([Date.UTC(date[0], date[1] - 1, date[2]), invalidCount])

              self.statistics.dates.push({
                date: date[2] + '/' + date[1] + '/' + date[0],
                valid: validCount,
                invalid: invalidCount
              })
            })

            chart.series[0].setData(highcharts.valid)
            chart.series[1].setData(highcharts.invalid)

            self.loading = false
          })
      },
      logout () {
        this.$nexus.logout()
        this.$router.push('/')
      },
      getSummaries (param) {
        const {columns, data} = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Total'
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              let value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = 'N/A'
          }
        })

        return sums
      }
    }
  }
</script>

<style>
  .valid-color {
    color: #2980b9 !important;
  }

  .invalid-color {
    color: #f39c12 !important;
  }

  .is-leaf {
    font-weight: bold;
  }

  .highcharts-credits {
    display: none;
  }
</style>

<style scoped>
  .container {
    padding: 20px 30px 0 30px;
    margin-top: 50px;
    background-color: #fff;
    border-radius: 0.5rem;
  }

  .connected {
    margin-top: 10px;
    color: #888;
  }

  @media (max-width: 767px) {
    .container {
      margin-top: 0;
      border-radius: 0;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?76800fb8